/**
   * Will scope the components script to the DOM element of the component.
   *
   * @param {string} name The name of the component
   * @param {element} component The component DOM element
   */
const register = (name, component) => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(`[data-component=${name}]`).forEach(el => component(el))
  })
}

/**
   * Loads the prefix of the component. Requires data-prefix inside DOM.
   *
   * @param {element} component The component element
   * @return {string} The prefix of the element
   */
const getPrefix = (component) => {
  return component.dataset.prefix
}

/**
   * Will attach scripts from an array (scripts) to the beginning of an element.
   * It is feasible for big libraries that should only be loaded on special pages.
   *
   * @param {array} scripts The array of script paths
   * @param {element} el The element where the scripts will be attached to
   * @param {function} attachRecall The function that should be called on success
   */
const attachScripts = (scripts, el, attachRecall) => {
  const attachPromises = (src, position) => {
    return new Promise(function (resolve, reject) {
      const script = document.createElement('script')
      script.src = src
      script.onload = resolve
      script.onerror = reject
      el.insertBefore(script, el.childNodes[position])
    })
  }

  let result = scripts.reduce((accumulatorPromise, currentValue, index) => {
    return accumulatorPromise.then(() => {
      return attachPromises(currentValue, index)
    })
  }, Promise.resolve())

  result
    .then(attachRecall)
    .catch((e) => {
      console.log('Error on attaching scripts: ', e)
    })
}

/**
   * Checks if the provided element is visible in the viewport. Returns true when it is.
   *
   * @param {element} el The element that is checked
   */
const isInViewport = (el) => {
  var bounding = el.getBoundingClientRect()
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

// check if a certain cookie is set
const getCookie = function (cookieName) {
  const value = '; ' + document.cookie
  const parts = value.split('; ' + cookieName + '=')
  return parts.length === 2 ? parts.pop().split(';').shift() : false
}

export {
  register,
  getPrefix,
  attachScripts,
  isInViewport,
  getCookie
}
